export enum SearchSource {
  Vacancies = 1,
  Summaries,
  Companies,
}